import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import App from './App';
import SimplePage from "./pages/simple";
import FeedbackPage from "./pages/feedback";
import reportWebVitals from './reportWebVitals';

// Re-evaluates on window resize so the desktop/simplified switch stays correct
const Home = () => {
    const [isDesktop, setIsDesktop] = React.useState(window.innerWidth > 900);
    React.useEffect(() => {
        const onResize = () => setIsDesktop(window.innerWidth > 900);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return isDesktop ? <App/> : <SimplePage/>;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route index element={<Home/>}/>
                <Route element={<SimplePage/>} path={'index.html'}/>
                <Route element={<FeedbackPage/>} path={'feedback'}/>
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
